export * from './trademark-entry-optimized.interface';
export * from './trademark-entry.interface';
